import { Link } from 'react-router-dom'
import { Badge } from '@/components/ui/badge'
import { TRAFFIC } from '@/lib/trafficLight'
import { cn } from '@/lib/utils'

const STATUS_LABELS = {
  green: 'OK',
  amber: 'Review',
  red: 'Action needed',
  grey: 'No data',
}

export function TrafficLightDot({ status, className, title }) {
  const traffic = TRAFFIC[status] ?? TRAFFIC.grey
  const label = STATUS_LABELS[status] ?? STATUS_LABELS.grey
  return (
    <span
      className={cn('inline-block shrink-0 rounded-full', traffic.dot, className)}
      title={title ?? label}
      aria-label={label}
    />
  )
}

export function PostureBadge({ status, label }) {
  const traffic = TRAFFIC[status] ?? TRAFFIC.grey
  if (!status || status === 'grey') {
    return <span className="text-muted-foreground text-sm">—</span>
  }
  return (
    <span className="inline-flex items-center gap-2">
      <TrafficLightDot status={status} className="h-2.5 w-2.5" />
      <Badge variant={traffic.badge}>{label ?? traffic.label}</Badge>
    </span>
  )
}

export function PostureLink({ agentId, status, tab, label }) {
  const traffic = TRAFFIC[status] ?? TRAFFIC.grey
  if (!status || status === 'grey') {
    return <span className="text-muted-foreground text-sm">—</span>
  }
  const href =
    !tab || tab === 'overview'
      ? `/agents/${agentId}`
      : `/agents/${agentId}?tab=${tab}`
  return (
    <Link
      to={href}
      className="inline-flex items-center gap-2 hover:opacity-80"
      title={`View ${label}`}
      onClick={(e) => e.stopPropagation()}
    >
      <TrafficLightDot status={status} className="h-2.5 w-2.5" />
      <Badge variant={traffic.badge}>{traffic.label}</Badge>
    </Link>
  )
}
